// src/assets/icons/CustomIcons.js

import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

// --- ACTIONS GROUP (Top Horizontal Bar) ---

export const MenuAddNew = (props) => (
  <SvgIcon {...props} viewBox='0 0 100 120'>
    <g transform='translate(25, 4)'>
      <circle cx='25' cy='60' r='22' fill='#4caf50' />
      <path
        d='M 25,48 V 72 M 13,60 h 24'
        stroke='#ffffff'
        strokeWidth='3'
        strokeLinecap='round'
      />
    </g>
    <text
      x='50'
      y='108'
      fontFamily='Arial'
      fontSize='18px'
      fontWeight='bold'
      fill='#333333'
      textAnchor='middle'>
      Add New
    </text>
  </SvgIcon>
);

export const MenuAddNewGrey = (props) => (
  <SvgIcon {...props} viewBox='0 0 100 120'>
    <g transform='translate(25, 4)'>
      <circle cx='25' cy='60' r='22' fill='#9e9e9e' />
      <path
        d='M 25,48 V 72 M 13,60 h 24'
        stroke='#ffffff'
        strokeWidth='3'
        strokeLinecap='round'
      />
    </g>
    <text
      x='50'
      y='108'
      fontFamily='Arial'
      fontSize='18px'
      fontWeight='normal'
      fill='#9e9e9e'
      textAnchor='middle'>
      Add New
    </text>
  </SvgIcon>
);

export const MenuDuplicate = (props) => (
  <SvgIcon {...props} viewBox='0 0 100 120'>
    <g transform='translate(25, 40) scale(5)'>
      <g strokeWidth='0'>
        <rect x='7.0072' y='7.886' width='.19002' height='.30879' fill='#fff' />
      </g>
      <g stroke='#000'>
        <ellipse
          cx='4.7584'
          cy='4.8102'
          rx='4.54'
          ry='4.5589'
          fill='#fff'
          strokeWidth='.34287'
        />
        <rect
          x='2.4556'
          y='1.3021'
          width='4.0408'
          height='5.7385'
          fill='#0037e3'
          strokeWidth='.15875'
        />
        <rect
          x='2.9573'
          y='2.56'
          width='4.0408'
          height='5.7385'
          fill='#00e33b'
          strokeWidth='.15875'
        />
      </g>
    </g>
    <text
      x='50'
      y='108'
      fontFamily='Arial'
      fontSize='18px'
      fontWeight='bold'
      fill='#333333'
      textAnchor='middle'>
      Duplicate
    </text>
  </SvgIcon>
);

export const MenuDuplicateGrey = (props) => (
  <SvgIcon {...props} viewBox='0 0 100 120'>
    <g transform='translate(25, 40) scale(5)'>
      <g strokeWidth='0'>
        <rect x='7.0072' y='7.886' width='.19002' height='.30879' fill='#fff' />
      </g>
      <g stroke='#000'>
        <ellipse
          cx='4.7584'
          cy='4.8102'
          rx='4.54'
          ry='4.5589'
          fill='#fff'
          strokeWidth='.34287'
        />
        <rect
          x='2.4556'
          y='1.3021'
          width='4.0408'
          height='5.7385'
          fill='#9e9e9e'
          strokeWidth='.15875'
        />
        <rect
          x='2.9573'
          y='2.56'
          width='4.0408'
          height='5.7385'
          fill='#bdbdbd'
          strokeWidth='.15875'
        />
      </g>
    </g>
    <text
      x='50'
      y='108'
      fontFamily='Arial'
      fontSize='18px'
      fontWeight='normal'
      fill='#9e9e9e'
      textAnchor='middle'>
      Duplicate
    </text>
  </SvgIcon>
);

export const MenuEdit = (props) => (
  <SvgIcon {...props} viewBox='0 0 100 120'>
    <g transform='translate(25, 4)'>
      <circle cx='25' cy='60' r='22' fill='#2196f3' />
      <path
        d='m 15,70 v -2 l 13,-13 2,2 -13,13 z m 14,-16 2,2 2,-2 -2,-2 z'
        fill='#ffffff'
      />
      <path d='M 15,70 H 35' stroke='#ffffff' strokeWidth='1.5' strokeLinecap='round' />
    </g>
    <text
      x='50'
      y='108'
      fontFamily='Arial'
      fontSize='18px'
      fontWeight='bold'
      fill='#333333'
      textAnchor='middle'>
      Edit
    </text>
  </SvgIcon>
);

export const MenuEditGrey = (props) => (
  <SvgIcon {...props} viewBox='0 0 100 120'>
    <g transform='translate(25, 4)'>
      <circle cx='25' cy='60' r='22' fill='#9e9e9e' />
      <path
        d='m 15,70 v -2 l 13,-13 2,2 -13,13 z m 14,-16 2,2 2,-2 -2,-2 z'
        fill='#ffffff'
      />
      <path d='M 15,70 H 35' stroke='#ffffff' strokeWidth='1.5' strokeLinecap='round' />
    </g>
    <text
      x='50'
      y='108'
      fontFamily='Arial'
      fontSize='18px'
      fontWeight='normal'
      fill='#9e9e9e'
      textAnchor='middle'>
      Edit
    </text>
  </SvgIcon>
);

export const MenuSave = (props) => (
  <SvgIcon {...props} viewBox='0 0 100 120'>
    <g transform='translate(25, 4)'>
      <circle cx='25' cy='60' r='22' fill='#ff9800' />
      <path
        d='m 16,60 6,6 12,-12'
        stroke='#ffffff'
        strokeWidth='3'
        fill='none'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </g>
    <text
      x='50'
      y='108'
      fontFamily='Arial'
      fontSize='18px'
      fontWeight='bold'
      fill='#333333'
      textAnchor='middle'>
      Save
    </text>
  </SvgIcon>
);

export const MenuSaveGrey = (props) => (
  <SvgIcon {...props} viewBox='0 0 100 120'>
    <g transform='translate(25, 4)'>
      <circle cx='25' cy='60' r='22' fill='#9e9e9e' />
      <path
        d='m 16,60 6,6 12,-12'
        stroke='#ffffff'
        strokeWidth='3'
        fill='none'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </g>
    <text
      x='50'
      y='108'
      fontFamily='Arial'
      fontSize='18px'
      fontWeight='normal'
      fill='#9e9e9e'
      textAnchor='middle'>
      Save
    </text>
  </SvgIcon>
);

export const MenuDelete = (props) => (
  <SvgIcon {...props} viewBox='0 0 100 120'>
    <g transform='translate(25, 4)'>
      <circle cx='25' cy='60' r='22' fill='#f44336' />
      <path
        d='M 17,53 H 33 M 19,53 V 68 H 31 V 53 m -9,-3 h 6 v 3 h -6 z'
        stroke='#ffffff'
        strokeWidth='2'
        fill='none'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='m 22,57 v 7 m 3,-7 v 7 m 3,-7 v 7'
        stroke='#ffffff'
        strokeWidth='1.5'
        strokeLinecap='round'
      />
    </g>
    <text
      x='50'
      y='108'
      fontFamily='Arial'
      fontSize='18px'
      fontWeight='bold'
      fill='#333333'
      textAnchor='middle'>
      Delete
    </text>
  </SvgIcon>
);

export const MenuDeleteGrey = (props) => (
  <SvgIcon {...props} viewBox='0 0 100 120'>
    <g transform='translate(25, 4)'>
      <circle cx='25' cy='60' r='22' fill='#9e9e9e' />
      <path
        d='M 17,53 H 33 M 19,53 V 68 H 31 V 53 m -9,-3 h 6 v 3 h -6 z'
        stroke='#ffffff'
        strokeWidth='2'
        fill='none'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='m 22,57 v 7 m 3,-7 v 7 m 3,-7 v 7'
        stroke='#ffffff'
        strokeWidth='1.5'
        strokeLinecap='round'
      />
    </g>
    <text
      x='50'
      y='108'
      fontFamily='Arial'
      fontSize='18px'
      fontWeight='normal'
      fill='#9e9e9e'
      textAnchor='middle'>
      Delete
    </text>
  </SvgIcon>
);

export const MenuIconCancel = (props) => (
  <SvgIcon {...props} viewBox='0 0 100 120'>
    <g transform='translate(25, 4)'>
      <circle cx='25' cy='60' r='22' fill='#000000ff' />
      <path
        d='M 17,52 33,68 M 33,52 17,68'
        stroke='#ffffff'
        strokeWidth='3'
        strokeLinecap='round'
      />
    </g>
    <text
      x='50'
      y='108'
      fontFamily='Arial'
      fontSize='18px'
      fontWeight='bold'
      fill='#333333'
      textAnchor='middle'>
      Cancel
    </text>
  </SvgIcon>
);

export const MenuIconCancelGrey = (props) => (
  <SvgIcon {...props} viewBox='0 0 100 120'>
    <g transform='translate(25, 4)'>
      <circle cx='25' cy='60' r='22' fill='#9e9e9e' />
      <path
        d='M 17,52 33,68 M 33,52 17,68'
        stroke='#ffffff'
        strokeWidth='3'
        strokeLinecap='round'
      />
    </g>
    <text
      x='50'
      y='108'
      fontFamily='Arial'
      fontSize='18px'
      fontWeight='normal'
      fill='#9e9e9e'
      textAnchor='middle'>
      Cancel
    </text>
  </SvgIcon>
);

// --- SHAPES GROUP ---

export const MenuMarkerColor = (props) => (
  <SvgIcon {...props} viewBox='0 0 100 90'>
    <circle cx='50' cy='35' r='22' fill='#ff5722' />
    <path
      d='m 50,23 c -5,0 -9,4 -9,9 0,7 9,15 9,15 0,0 9,-8 9,-15 0,-5 -4,-9 -9,-9 z'
      fill='#ffffff'
    />
    <circle cx='50' cy='32' r='3' fill='#ff5722' />
  </SvgIcon>
);

export const MenuPolygonColor = (props) => (
  <SvgIcon {...props} viewBox='0 0 100 90'>
    <circle cx='50' cy='35' r='22' fill='#9c27b0' />
    <path
      d='m 50,23 11,8 -3,14 H 42 L 39,31 Z'
      fill='none'
      stroke='#ffffff'
      strokeWidth='2.5'
    />
    <circle cx='50' cy='23' r='3' fill='#ffffff' />
    <circle cx='61' cy='31' r='3' fill='#ffffff' />
    <circle cx='58' cy='45' r='3' fill='#ffffff' />
    <circle cx='42' cy='45' r='3' fill='#ffffff' />
    <circle cx='39' cy='31' r='3' fill='#ffffff' />
  </SvgIcon>
);

export const MenuLineColor = (props) => (
  <SvgIcon {...props} viewBox='0 0 100 90'>
    <circle cx='50' cy='35' r='22' fill='#00bcd4' />
    <path d='M 40,43 60,27' stroke='#ffffff' strokeWidth='3' strokeLinecap='round' />
    <circle cx='40' cy='43' r='2.5' fill='#ffffff' />
    <circle cx='60' cy='27' r='2.5' fill='#ffffff' />
  </SvgIcon>
);

export const MenuMarkerGrey = (props) => (
  <SvgIcon {...props} viewBox='0 0 100 90'>
    <circle cx='50' cy='35' r='22' fill='#9e9e9e' />
    <path
      d='m 50,23 c -5,0 -9,4 -9,9 0,7 9,15 9,15 0,0 9,-8 9,-15 0,-5 -4,-9 -9,-9 z'
      fill='#ffffff'
    />
    <circle cx='50' cy='32' r='3' fill='#9e9e9e' />
  </SvgIcon>
);

export const MenuPolygonGrey = (props) => (
  <SvgIcon {...props} viewBox='0 0 100 90'>
    <circle cx='50' cy='35' r='22' fill='#9e9e9e' />
    <path
      d='m 50,23 11,8 -3,14 H 42 L 39,31 Z'
      fill='none'
      stroke='#ffffff'
      strokeWidth='2.5'
    />
    <circle cx='50' cy='23' r='3' fill='#ffffff' />
    <circle cx='61' cy='31' r='3' fill='#ffffff' />
    <circle cx='58' cy='45' r='3' fill='#ffffff' />
    <circle cx='42' cy='45' r='3' fill='#ffffff' />
    <circle cx='39' cy='31' r='3' fill='#ffffff' />
  </SvgIcon>
);

export const MenuLineGrey = (props) => (
  <SvgIcon {...props} viewBox='0 0 100 90'>
    <circle cx='50' cy='35' r='22' fill='#9e9e9e' />
    <path d='M 40,43 60,27' stroke='#ffffff' strokeWidth='3' strokeLinecap='round' />
    <circle cx='40' cy='43' r='2.5' fill='#ffffff' />
    <circle cx='60' cy='27' r='2.5' fill='#ffffff' />
  </SvgIcon>
);

// --- EXPORT FROM BARREL ---
export * from './CustomIconsAdd1';
export * from './CustomIconsAdd2';
export * from './CustomIconsAdd3';
export * from './CustomIconsAdd4';
